import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
// import App from './App';
import reportWebVitals from './reportWebVitals';
import App from "./App";
import axios from 'axios';

axios.defaults.baseURL = 'https://us-central1-codebookmark-be2bc.cloudfunctions.net/v1';
// axios.defaults.baseURL = 'http://localhost:5000/codebookmark-be2bc/us-central1/v1';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App/>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
